import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Box } from 'components/common/box';
import { ProfileCompetencies, ProfileInfo, ProfileSummaryHeader } from '.';

const ProfileLimited = () => {
  const {
    pageState: { user: targetUser },
    serverConfig
  } = useReduxState();

  return (
    <div className="summary">
      <div className="main">
        <Box>
          <div className="inner">
            <ProfileSummaryHeader
              isLimitedView={true}
              isPreview={true}
              isUserPage={true}
              targetUser={targetUser}
            />
            <div className="info">
              <ProfileInfo
                hideCustomAttributes={true}
                isPreview={true}
                isUserPage={true}
                targetUser={targetUser}
              />
            </div>
          </div>
        </Box>
        {serverConfig.userEnableOtherProfiles.enableCompetencyEndorsements && (
          <div className="section">
            <ProfileCompetencies
              apiUrl="/admin/users-user"
              isPreview={true}
              isUserPage={true}
              targetUser={targetUser}
            />
          </div>
        )}
      </div>

      <style jsx>{`
        .info {
          margin-top: 40px;
        }
        .section {
          margin-top: 20px;
        }
        .summary {
          align-items: flex-start;
          display: flex;
          flex-direction: row;
          gap: 30px;
        }
        .main {
          flex-grow: 1;
          min-width: 0;
        }
        @media (min-width: ${breakpoints.medium}px) {
          .inner {
            padding: 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default ProfileLimited;
